
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const ReferralRulesHeader = () => {
  return (
    <CardHeader>
      <CardTitle>Regras de Indicação</CardTitle>
      <CardDescription>
        Configure os benefícios para indicados e indicadores
      </CardDescription>
    </CardHeader>
  );
};
